// extracted by mini-css-extract-plugin
module.exports = {"root":"add-voice-actor-page_root__3BWOY"};